import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useUrlGenerator } from '@folklore/react-container';
import { setPage as setPageAction } from '../../actions/SiteActions';
import { loadPage } from '../../lib/request';

import ArticleHeading from './ArticleHeading';
import StoryHeading from './StoryHeading';
import Blocks from '../blocks/Blocks';
import Facebook from '../icons/socials/Facebook';
import Twitter from '../icons/socials/Twitter';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/article.scss';

const propTypes = {
    article: PropTypes.array.isRequired, // eslint-disable-line
    setPage: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Article = ({ setPage, article, className }) => {
    const urlGenerator = useUrlGenerator();

    useEffect(() => {
        loadPage().then(page => {
            setPage(page);
        });
    }, []);

    const header = {
        title: article.title,
        author: article.author,
        // date: article.date,
        subheading: article.subheading,
        image: article.image,
    };

    return (
        <article
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.topBackground} />

            {article.type === 'article' ? (
                <ArticleHeading item={header} className={styles.articleHeader} />
            ) : null}
            {article.type === 'story' ? (
                <StoryHeading item={article} className={styles.storyHeader} />
            ) : null}
            <div className={styles.columns}>
                <div className={styles.social}>
                    <a
                        href="https://facebook.com/findingsallydoc"
                        title="Facebook"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                    >
                        <Facebook className={styles.icon} />
                    </a>
                    <a
                        href="https://twitter.com/findingsallydoc"
                        title="Twitter"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                    >
                        <Twitter className={styles.icon} />
                    </a>
                </div>
                <div className={styles.articleInner}>
                    <div className={styles.blocksContainer}>
                        <Blocks
                            blocks={article.blocks}
                            className={styles.blocks}
                            blockClassName={styles.block}
                        />
                    </div>
                    <div className={styles.backToListBottom}>
                        {article.type === 'story' ? (
                            <Link to={urlGenerator.route('stories')}>Back to List</Link>
                        ) : (
                            <Link to={urlGenerator.route('articles')}>Back to List</Link>
                        )}
                    </div>
                </div>
            </div>
        </article>
    );
};

Article.propTypes = propTypes;
Article.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site: { page } }) => ({
        article: page,
    }),
    dispatch => ({
        setPage: page => dispatch(setPageAction(page)),
    }),
)(Article);

export default WithStateContainer;
